<div class="cuppa-dropdown" (clickOutside)="closeDropdown()">
              <div class="selected-list">
            <div class="c-btn" (click)="toggleDropdown($event)" [ngClass]="{'disabled': settings.disabled}">
                <span *ngIf="selectedItems?.length == 0">{{settings.text}}</span>
                <span *ngIf="settings.singleSelection">
                    <span *ngFor="let item of selectedItems;trackBy: trackByFn;">
                        {{item.itemName}}
                    </span>
                </span>
                <div class="c-list" *ngIf="selectedItems?.length > 0 && !settings.singleSelection && selectedItems?.length == settings.badgeShowLimit">
                    <div class="c-token" *ngFor="let item of selectedItems;trackBy: trackByFn;let k = index" [hidden]="k > settings.badgeShowLimit-1">
                        <span class="c-label primary-color-bg">{{item.itemName}}</span>
                    </div>
                </div>
                <div *ngIf="data.length!=selectedItems.length">
                    <span *ngIf="selectedItems?.length > settings.badgeShowLimit">{{selectedItems?.length}} Selected</span>
                </div>
                <div *ngIf="data.length==selectedItems.length && data.length>1">
                        <span>All Selected</span>
                    </div>
                <span class="fa" [ngClass]="{'fa-angle-down': !isActive,'fa-angle-up':isActive}"></span>
            </div>
        </div>
        <div class="dropdown-list" [hidden]="!isActive">
            <div class="arrow-up"></div>
            <div class="list-area">
                <div class="list-filter" *ngIf="data.length > 0 && settings.enableSearchFilter">
                    <span class="fa fa-search"></span>
                    <input type="text" [placeholder]="settings.searchPlaceholderText" [(ngModel)]="filter.itemName">
                    <div *ngIf="settings.AdvertisersDropDown==false">
                        <div class="pure-checkbox select-all"
                            *ngIf="settings.enableCheckAll && !settings.singleSelection && !settings.limitSelection"
                            (click)="toggleSelectAll()">
                        <input type="checkbox" [checked]="isSelectAll"
                                [disabled]="settings.limitSelection == selectedItems?.length"/>
                        <label>
                            <span [hidden]="isSelectAll"></span>
                            <span [hidden]="!isSelectAll"></span>
                        </label>
                        <span [hidden]="isSelectAll">{{settings.selectAllText}}</span>
                        <span [hidden]="!isSelectAll">{{settings.unSelectAllText}}</span>
                        </div>
                    </div>
                    <div *ngIf="settings.AdvertisersDropDown==true">
                        <div class="pure-checkbox select-all"
                            *ngIf="settings.enableCheckAll && !settings.singleSelection && !settings.limitSelection"
                            (click)="CustomtoggleSelectAll()">
                            <input type="checkbox" [checked]="true" *ngIf="selectedItems.length>0"
                                    [disabled]="settings.limitSelection == selectedItems?.length"/>
                            <label>
                                <span [hidden]="isSelectAll"></span>
                                <span [hidden]="!isSelectAll"></span>
                            </label>
                            <span [hidden]="!selectedItems.length>0">{{settings.unSelectAllText}}</span>
                        </div>
                    </div>
                </div>
                <span>{{content}}</span>
                <div *ngIf="content=='Select all campaigns'" class="dropdown-list-container">
                        <ul [style.maxHeight]="settings.maxHeight+'px'">
                                <li *ngFor="let item of data | listFilter:filter; let i = index;" (click)="onItemClick(item,i,$event)"
                                    class="pure-checkbox">
                                    <input type="checkbox" [checked]="isSelected(item)"
                                           [disabled]="settings.limitSelection == selectedItems?.length && !isSelected(item)"/>
                                    <label>{{item.itemName}}</label>
                                </li>
                        </ul>
                </div>
                <div *ngIf="content!='Select all campaigns'" class="dropdown-list-container">
                    <div #advertisersDropDown>
                            <ul [style.maxHeight]="settings.maxHeight+'px'">
                                    <li *ngFor="let item of data | listFilter:filter; let i = index;" (click)="advtDropdownClick(item,i,$event)"
                                        class="pure-checkbox">
                                        <input type="checkbox" [checked]="isSelected(item)"
                                               [attr.disabled] = "active === 1 ? 'disabled' : null"/>
                                        <label>{{item.itemName}}</label>
                                    </li>
                            </ul>
                    </div>
                </div>
                <h5 class="list-message" *ngIf="data?.length == 0">No Data Available</h5>
            </div>
        </div>
    </div>